import { useState, useEffect, createRef, useContext } from "react";
import FetchUtil from "../../utils/FetchUtil";
import Select from 'react-select';
import { ddStyles } from "../../utils/CommonStyles.js";
import UserContext from "../../contexts/UserContext";

let companyOptions = [];
const CompanyProductFilter = ({ t, setErrorValue, onClickFilterCallback, defaultKeyword, defaultCompanyId, 
fetchCompanyProducts, setSurveyProductList, setCompanyProductList, setAdd }) => {

	const [refs] = useState({
		searchData: createRef(),
	});
	const [vars] = useState({
		searchData: defaultKeyword,
	});
	const [companyLoaded, setCompanyLoaded] = useState(false);
	const [companyId, setCompanyId] = useState(defaultCompanyId);
	const [companySelected, setCompanySelected] = useState({ name: "companyId", label: "", value: defaultCompanyId });
	const userCtx = useContext(UserContext);
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchCompanies();
	}, []);

	function fetchCompanies() {
		setErrorValue("");
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false, userCompanyId:userCompanyId }),
		};
		try {
			FetchUtil.fetchAPI("FetchCompanies", "/Service/CompanyService/FetchCompanies", requestOptions, fetchCompaniesSuccess, fetchCompaniesFail);
		} catch (error) {
			throw new Error(error.message);
		}
	}

	function fetchCompaniesFail(redirect) {
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.companyListNotRetrieved"));
	}
	function fetchCompaniesSuccess(responseData) {
		let fetchCompaniesResponse;
		if (responseData) {
			fetchCompaniesResponse = responseData.fetchCompaniesResponse;
			if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "0") {
				setCompanyValues(fetchCompaniesResponse.companies);
			} else if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchCompaniesResponse) {
				setErrorValue(t("error.error") + " " + fetchCompaniesResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
	}
	function setCompanyValues(companyObj) {
		let companyValue = {};
		companyOptions = [];
		companyOptions.push({ label: "", value: 0 });
		if (companyObj && companyObj.length > 0) {
			companyObj.map((company, index) => {
				companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
				companyValue.value = company.companyId;
				companyOptions.push(companyValue);
				companyValue = {};
			});
		}
		setCompanyLoaded(true);
	}

	const companyHandler = (selectedOption, action) => {
		let selectedCompanyId = selectedOption ? selectedOption.value : 0;
		let selectedCompanyName = selectedOption ? selectedOption.label : "";
		if (companyId === selectedCompanyId) {
			return
		}
		setCompanyId(selectedCompanyId);
		setCompanySelected({ ...companySelected, label: selectedCompanyName, value: selectedCompanyId });
		if(fetchCompanyProducts){
			setSurveyProductList([]);	
			fetchCompanyProducts(selectedCompanyId);
		}
		if(setCompanyProductList){
			setCompanyProductList([]);
		}
		if(setAdd){
			setAdd(false);
		}
	}

	const onKeywordChange = (e) => {
		const { name, value } = e.target;
		//console.log(name + "  " + value);
		vars[name] = value;
	}
	const onClickSearch = () => {
		let searchValue = vars.searchData.trim();
		if (!companyId || companyId === 0) {
			setErrorValue(t("error.companyReqd"));
			return;
		}
		onClickFilterCallback(searchValue, companyId);
	}
	const onClickClear = () => {
		refs.searchData.current.value = "";
		vars.searchData = "";
		onClickFilterCallback("", companyId);
	}
	return (
		<div className="form-group search-box">
			<input
				id="searchData"
				name="searchData"
				ref={refs.searchData}
				defaultValue={vars.searchData}
				onChange={onKeywordChange}
				type="text"
				placeholder={(!fetchCompanyProducts) ? "Search Product": "Search Product/ Survey"}
				className="search-text"
			/>
			<div className="form-group search-dd">
				<label className="form-label">
					<span className="form_required">*</span>
					{t("page.company")}
				</label>
				<Select
					name="companyId"
					options={companyOptions}
					onChange={companyHandler}
					placeholder={""}
					value={companySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="companyId-input"
					styles={ddStyles}
				/>
			</div>
			<button
				type="submit"
				className="btn btn-primary btn-block search-button"
				onClick={onClickSearch}
			>
				<span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
			</button>

			<button className="btn btn-primary btn-block search-clear" onClick={onClickClear}>{t("page.clear")}
			</button>
		</div>
	)
}

export default CompanyProductFilter;